import { DirectUploadMedia } from "libs/directUpload";

export const getFileFromRemoteMedia = async (media: DirectUploadMedia) => {
  let url = media.url;
  if (url.includes("chapshop-bucket.s3.eu-central-1.amazonaws.com")) {
    url = url.replace(
      "chapshop-bucket.s3.eu-central-1.amazonaws.com",
      "d8ioqfhnu0yes.cloudfront.net"
    );
  } else if (url.includes("chapshop.s3.eu-west-3.amazonaws.com")) {
    url = url.replace(
      "chapshop.s3.eu-west-3.amazonaws.com",
      "d1cevf4rl7bfy1.cloudfront.net"
    );
  }
  const response = await fetch(url);

  const blob = await response.blob();
  return new File([blob], media.fileName, { type: media.contentType });
};
